import React, { type HTMLAttributes, type ReactNode } from "react";
import { BaseInputAdornmentContext } from "src/components/BaseInput/BaseInputAdornmentContext.tsx";
import { css } from "@emotion/react";
import { selectClasses } from "src/components/Select/Select.constants.ts";

export const StartAdornment = ({
  startAdornment,
  disabled = false,
  isButton,
  ...rest
}: {
  startAdornment: ReactNode;
  disabled?: boolean;
  isButton: boolean;
} & HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      css={isButton ? buttonAdornmentStyles : null}
      className={selectClasses.startAdornment}
      onClick={(e) => {
        if (!isButton) {
          e.stopPropagation();
        }
      }}
      {...rest}
    >
      <BaseInputAdornmentContext.Provider
        value={{
          disabled,
          position: "end",
        }}
      >
        {startAdornment}
      </BaseInputAdornmentContext.Provider>
    </div>
  );
};

const buttonAdornmentStyles = () => css`
  display: flex;
  align-items: center;
  margin-left: 10px;
`;
